import styled from 'styled-components';

const RoadmapContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;

  @media (max-width: 768px) {
    bottom: 15px;
    right: 15px;
    gap: 8px;
  }
`;

const RoadmapLink = styled.a<{ $variant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'quinary' }>`
  padding: ${props => props.$variant === 'secondary' || props.$variant === 'tertiary' || props.$variant === 'quaternary' || props.$variant === 'quinary' ? '10px 20px' : '15px 30px'};
  background: ${props => {
    if (props.$variant === 'secondary') return 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)';
    if (props.$variant === 'tertiary') return 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)';
    if (props.$variant === 'quaternary') return 'linear-gradient(135deg, #0891b2 0%, #0e7490 100%)';
    if (props.$variant === 'quinary') return 'linear-gradient(135deg, #e67e22 0%, #d35400 100%)';
    return 'linear-gradient(135deg, #6B8E23 0%, #556B2F 100%)';
  }};
  color: white;
  text-align: center;
  text-decoration: none;
  border-radius: 50px;
  font-size: ${props => props.$variant === 'secondary' || props.$variant === 'tertiary' || props.$variant === 'quaternary' || props.$variant === 'quinary' ? '14px' : '16px'};
  font-weight: bold;
  box-shadow: ${props => {
    if (props.$variant === 'secondary') return '0 8px 25px rgba(52, 152, 219, 0.5)';
    if (props.$variant === 'tertiary') return '0 8px 25px rgba(124, 58, 237, 0.5)';
    if (props.$variant === 'quaternary') return '0 8px 25px rgba(8, 145, 178, 0.5)';
    if (props.$variant === 'quinary') return '0 8px 25px rgba(230, 126, 34, 0.5)';
    return '0 10px 30px rgba(107, 142, 35, 0.5)';
  }};
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    transform: translateY(-5px);
    box-shadow: ${props => {
      if (props.$variant === 'secondary') return '0 12px 35px rgba(52, 152, 219, 0.7)';
      if (props.$variant === 'tertiary') return '0 12px 35px rgba(124, 58, 237, 0.7)';
      if (props.$variant === 'quaternary') return '0 12px 35px rgba(8, 145, 178, 0.7)';
      if (props.$variant === 'quinary') return '0 12px 35px rgba(230, 126, 34, 0.7)';
      return '0 15px 40px rgba(107, 142, 35, 0.7)';
    }};
  }

  &:active {
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    font-size: ${props => props.$variant === 'secondary' || props.$variant === 'tertiary' || props.$variant === 'quaternary' || props.$variant === 'quinary' ? '12px' : '14px'};
    padding: ${props => props.$variant === 'secondary' || props.$variant === 'tertiary' || props.$variant === 'quaternary' || props.$variant === 'quinary' ? '8px 16px' : '12px 20px'};
  }
`;

export const RoadmapButton = () => {
  return (
    <RoadmapContainer>
      <RoadmapLink
        href="/teach-mobile-arch.html"
        target="_blank"
        rel="noopener noreferrer"
        $variant="quinary"
      >
        Mobile Slides
      </RoadmapLink>
      <RoadmapLink
        href="/mobile-architecture-deep-dive.html"
        target="_blank"
        rel="noopener noreferrer"
        $variant="quaternary"
      >
        Arquitetura Mobile
      </RoadmapLink>
      <RoadmapLink
        href="/developer-strategic-planning-2026.html"
        target="_blank"
        rel="noopener noreferrer"
        $variant="tertiary"
      >
        Dev 2026
      </RoadmapLink>
      <RoadmapLink
        href="/ai-agents-roadmap-2026-associate.html"
        target="_blank"
        rel="noopener noreferrer"
        $variant="secondary"
      >
        Roadmap Iniciante
      </RoadmapLink>
      <RoadmapLink
        href="/ai-agents-roadmap-2026.html"
        target="_blank"
        rel="noopener noreferrer"
        $variant="primary"
      >
        Roadmap Avancado
      </RoadmapLink>
    </RoadmapContainer>
  );
};
